import { DaoService } from "./DaoService";

export class EtapeService extends DaoService {
    static CLASS_NAME = 'App\\Models\\Etape';

    static getInstance() {
        return super.getInstance('etape');
    }

    all() {
        return EtapeService.get(`${this.prefix}/all`);
    }
    
    findByAffaire(uid) {
        return EtapeService.get(`${this.prefix}/${uid}/affaire`);
    }

    search(data) {
        return EtapeService.post(`${this.prefix}/search`, data);
    }

    enable(idOrUid) {
        return EtapeService.post(`${this.prefix}/${idOrUid}/enable`);
    }

    disable(idOrUid) {
        return EtapeService.post(`${this.prefix}/${idOrUid}/disable`);
    }

}